import { first, replace } from 'lodash'
import { getImagePath } from 'helpers/asset'
import Country from 'components/country/country'
import { COUNTRY_CODE } from 'constants/index'

export const countryHelper = {
  getCountryFlag,
  getCountries,
}

function getCountryFlag(countryCode) {
  switch (countryCode?.toLowerCase()) {
    case COUNTRY_CODE.VN:
      return getImagePath('country/country-icon-vn.png')
    case COUNTRY_CODE.ID:
      return getImagePath('country/country-icon-indo.png')
    case COUNTRY_CODE.TH:
      return getImagePath('country/country-icon-thailand.png')
    default:
      return ''
  }
}

function formatCountryName(name) {
  if (!name) return ''
  const regex = new RegExp(/\(\D*\)/)
  const result = name.match(regex)
  if (result) {
    return replace(name, first(result), '').trim()
  }
  return name
}

function getCountries() {
  const countries = Country.getAll()
  return countries.map((country) => {
    const countryName = formatCountryName(country.name)
    return {
      label: countryName,
      value: countryName,
    }
  })
}
